"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialMedia = void 0;
exports.socialMedia = {
    facebook: 'https://www.facebook.com/featherinsurance/',
    instagram: 'https://www.instagram.com/feather.insurance/',
    linkedIn: 'https://www.linkedin.com/company/feather-insurance',
};
